import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// Welcome - Component
import Welcome from '../components/login/Welcome'

// Admin - Components
import DashboardAdmin from '../components/admin/Dashboard'
import FilesAdmin from '../components/admin/Files'
import AddFileAdmin from '../components/admin/AddFile'
import CategoriesAdmin from '../components/admin/Categories'
import AddCategoryAdmin from '../components/admin/AddCategory'
import CategoryAdmin from '../components/admin/Category'

// Client - Components
import DashboardClient from '../components/user/Dashboard'
import CategoriesClient from '../components/user/Categories'
import CategoryClient from '../components/user/Category'

// Routes
const routes = [
  { path: '/', name:'welcome', component: Welcome },
  { path: '/admin', name: 'dashboard-admin', component: DashboardAdmin,
    children: [{
      path: 'files',
      name: 'files-admin',
      component: FilesAdmin
    },
    {
      path: 'add-file',
      name: 'add-file-admin',
      component: AddFileAdmin
    },
    {
      path: 'category/:slug',
      name: 'category-admin',
      component: CategoryAdmin
    },
    {
      path: 'categories',
      name: 'categories-admin',
      component: CategoriesAdmin
    },
    {
      path: 'add-category',
      name: 'add-category-admin',
      component: AddCategoryAdmin
    }]
  },
  { path: '/user', name: 'dashboard-user', component: DashboardClient,
    children: [{
      path: 'files',
      name: 'files-client',
      component: CategoriesClient
    },
    {
      path: 'category/:slug',
      name: 'category-client',
      component: CategoryClient
    }]
  }
]

// Export Routes
export const router = new VueRouter({
	mode: 'history',
	routes
})



// WEBPACK FOOTER //
// ./src/routes/index.js